<template>
  <div style="height: 100%">
    <!-- <div style="position:fixed; width:100%; height:30px; background:#000; color:#fff;">
      <div class="d-flex align-items-center justify-content-center">
        <h3>{{ deviceId }} - {{windowSize}}</h3>
      </div>
    </div> -->
    <div
      v-if="
        deviceId == 'mobile_potrait' ||
        deviceId == 'mobile_landscape' ||
        deviceId == 'ipad_potrait' ||
        deviceId == 'ipad_landscape'
      "
      class="mobile-info-wrap"
    >
      <div class="container">
        <!-- <div class="screen-info-wrapper">
          
          <div class="screen-info-image mb-6" v-if="clientImageUrl != null">
            <img :src="clientImageUrl" />
          </div>
          <div class="screen-info-image mb-6" v-else>
            <img src="../assets/Images/e2m.live-white-screen.png" />
          </div>
          <div class="screen-info-text">
            <h4>As an attendee your experience is our priority.</h4>
          </div>
          <div class="screen-info-text-description resolution-statement">
            <p>Your screen resolution is below the minimum required 1280 x 768.
            Please change display settings in Windows or Mac and click on below button to Retry.
            </p>
            <div class="d-flex justify-content-center align-items-center">
              <v-btn @click="goToPrevious()" small color="primary" class="mb-3"><v-icon color="#fff" size="15px" class="mr-1">mdi-reload</v-icon> Retry</v-btn>
              <p  class="mx-2" style="color: #ffffff">Or</p>
              <v-btn @click="goToHome()" small color="primary" class="mb-3">Back to home</v-btn>
            </div>
          </div>
          <div class="screen-info-text-description">
            <p>
              For best experience, please join the Live session using Chrome or Edge browser from Desktop.
            </p>
            
            <div class="mt-3 divider">
              <p>You may also download our Apps.</p>
            </div>
          </div>

          <div class="app-download-button">
            <a
              v-if="clientDomainUrl == 'https://www.thailandvirtualevent.com'"
              href="https://play.google.com/store/apps/details?id=ws.e2m.onair.kotlin.northstar&hl=en_US&gl=US"
              class="app-download-btn-mobile"
              ><img src="../assets/Images/g-store.png" />
            </a>
            <a
              v-else
              href="https://play.google.com/store/apps/details?id=ws.e2m.onair.kotlin"
              class="app-download-btn-mobile"
              ><img src="../assets/Images/g-store.png" />
            </a>

            <a
              href="https://apps.apple.com/in/app/e2m-onair/id1516618112"
              class="app-download-btn-mobile"
              ><img src="../assets/Images/app-store.png"
            /></a>
          </div>
        </div> -->

        <div class="product-top-logoofpage">
          <div v-if="clientImageUrl != null" class="product-logo-hld">
            <img :src="clientImageUrl" />
          </div>
          <div v-else class="product-logo-hld">
            <img src="../assets/Images/screeninfo/logo-black.svg" />
          </div>
        </div>
        <div class="screeninfo-details-hld">
          <div class="screen-info-left-hld">
            <img src="../assets/Images/screeninfo/monitor.png" />
            <p>
              As an attendee your experience is our priority. Your screen
              resolution is below the minimum required
              <b>1280 X 768 (Layout should be 100%)</b>. Please change display
              settings in Windows or Mac and click on below button to retry.
            </p>
            <div class="screen-buttons-hld mt-2">
              <!-- <v-btn @click="goToPrevious()" outlined width="125px" height="45px" class="retry-screen-button mr-2"><img src="../assets/Images/screeninfo/refresh.svg" class="mr-2"/> Retry</v-btn> -->
              <v-btn
                @click="goToHome()"
                dark
                width="165px"
                height="45px"
                color="#1a73e8"
                class="back-home-screen"
                ><img
                  src="../assets/Images/screeninfo/app-lobby-menu.svg"
                  class="mr-2"
                />
                Back To Home</v-btn
              >
            </div>
          </div>
          <div class="screen-info-right-hld">
            <div
              class="
                d-flex
                justify-content-center justify-content-md-start
                align-items-center
                mb-5
              "
            >
              <img src="../assets/Images/screeninfo/edge.png" class="mr-3" />
              <img src="../assets/Images/screeninfo/chrome.png" />
            </div>
            <p>
              For best experience, please join the live session using Chrome or
              Edge browser from Desktop.
            </p>
            <div class="app-download-hld mt-12">
              <p>You may also download our Apps.</p>
              <div
                class="
                  d-flex
                  justify-content-center justify-content-md-start
                  align-items-center
                "
              >
                <a
                  v-if="
                    clientDomainUrl == 'https://www.thailandvirtualevent.com'
                  "
                  herf="https://play.google.com/store/apps/details?id=ws.e2m.onair.kotlin.northstar&hl=en_US&gl=US"
                  target="_blank"
                  class="d-inline-block mr-2"
                  ><img src="../assets/Images/screeninfo/playstore.png"
                /></a>
                <a
                  v-else
                  herf="https://play.google.com/store/apps/details?id=ws.e2m.onair.kotlin"
                  target="_blank"
                  class="d-inline-block mr-2"
                  ><img src="../assets/Images/screeninfo/playstore.png"
                /></a>
                <a
                  herf="https://apps.apple.com/in/app/e2m-onair/id1516618112"
                  target="_blank"
                  class="d-inline-block"
                  ><img src="../assets/Images/screeninfo/appstore.png"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-else-if="deviceId == 'ipad_potrait' || deviceId == 'ipad_landscape'" class="ipad-info-wrap">
      <div class="container">
        <div class="screen-info-wrapper">
          <div class="screen-info-text">
            <h4>As an attendee your experience is our priority.</h4>
          </div>
          <div class="screen-info-image" v-if="clientImageUrl != null">
            <img :src="clientImageUrl" />
          </div>
          <div class="screen-info-image" v-else>
            <img src="../assets/Images/e2m.live-white-screen.png" />
          </div>
          <div class="screen-info-roate-image my-12">
            <img src="../assets/Images/rotate-device.png" />
          </div>
          <div class="screen-info-text-description">
            <p style="font-size: 20px">
              For best experience, please rotate you device in Landscape mode.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex align-items-center justify-content-center">
      <h1 class="mt-12">go to source page</h1>
    </div> -->
  </div>
</template>
<style scoped>
.screen-info-text-description.resolution-statement {
  width: 846px;
  margin: 0 auto;
}
.screen-info-text-description.resolution-statement p {
  font-size: 18px;
}
.screen-info-text-description.resolution-statement button {
  font-size: 15px;
  font-weight: 400;
  color: #fff;
  text-transform: capitalize;
}
.app-download-button a {
  height: 50px;
  width: 150px;
}
@media screen and (min-width: 768px) and (max-width: 820px) {
  .screen-info-text-description.resolution-statement {
    width: 100%;
  }
  .ipad-info-wrap {
    background: #132a3b;
    height: calc(100vh - 50px);
  }
  .screen-info-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .screen-info-text {
    text-align: center;
    margin-top: 20px;
  }
  .screen-info-text-description {
    text-align: center;
    margin: 20px 0;
  }
  .screen-info-text h4 {
    font-size: 24px;
    font-weight: 600;
    color: #fff;
  }
  .screen-info-image {
    height: 150px;
    width: 362px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
  }
  .screen-info-image img {
    max-width: 100%;
    height: auto;
  }
  .screen-info-text-description p {
    font-size: 14px;
    font-weight: 400;
    color: #fff;
  }
  .app-download-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .app-download-button a {
    display: inline-flex;
    margin-right: 10px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border: 2px solid #fff;
    border-radius: 5px;
    overflow: hidden;
    height: 50px;
    width: 150px;
  }
  .app-download-button a:last-child {
    margin-right: 0px;
  }
  .app-download-button a img {
    max-width: 100%;
    height: 100%;
  }
  .divider {
    display: block;
    position: relative;
  }
  .divider p {
    height: 20px;
    /* width: 30px; */
    display: inline-block;
    margin: 0 auto;
    background: #132a3b;
    position: relative;
  }
  .divider:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background: #214a66;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .screen-info-roate-image {
    width: 250px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 767px) {
  .screen-info-text-description.resolution-statement {
    width: 100%;
  }
  .ipad-info-wrap {
    background: #132a3b;
    height: calc(100vh - 50px);
  }
  .screen-info-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .screen-info-text {
    text-align: center;
    margin-top: 0px;
  }
  .screen-info-text-description {
    text-align: center;
    margin: 20px 0;
  }
  .screen-info-text h4 {
    font-size: 24px;
    font-weight: 600;
    color: #fff;
  }
  .screen-info-image {
    height: auto;
    width: 150px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
  .screen-info-image img {
    max-width: 100%;
    height: auto;
  }
  .screen-info-text-description p {
    font-size: 14px;
    font-weight: 400;
    color: #fff;
  }
  .app-download-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .app-download-button a {
    display: inline-flex;
    margin-right: 10px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border: 2px solid #fff;
    border-radius: 5px;
    overflow: hidden;
    height: 50px;
    width: 150px;
  }
  .app-download-button a:last-child {
    margin-right: 0px;
  }
  .app-download-button a img {
    max-width: 100%;
    height: 100%;
  }
  .divider {
    display: block;
    position: relative;
  }
  .divider p {
    height: 20px;
    /* width: 30px; */
    display: inline-block;
    margin: 0 auto;
    background: #132a3b;
    position: relative;
  }
  .divider:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background: #214a66;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

@media only screen and (min-width: 480px) and (max-width: 820px) {
  .ipad-info-wrap {
    height: 100vh;
  }
}
</style>

<script>
//import db from "../components/firebaseInit";
import jQuery from "jquery";
import router from "@/router";
import store from "@/store";
import EnvironmentInit from './EnvironmentInit';
let $ = jQuery;
var self;
export default {
  data() {
    return {
      androidAppUrl: null,
      iosAppUrl: null,
      clientImageUrl: null,
      clientDomainUrl: null,
      deviceId: "",
      windowSize: "",
      iPadLandscapePlayerSupport: false,
    };
  },
  created() {
    self = this;
    self.clientDomainUrl = location.origin;
  },
  async mounted() {
    $(window).resize(function () {
      self.initScreen();
    });
    self.initScreen();
    //alert("Screen Info");
  },
  methods: {
    goToPrevious() {
      //this.$router.back();
      if (window.history.length > 1) {
        this.$router.go(-2);
      } else {
        router.push("/home");
      }

      //var lastValidPath = store.getters.getRouteName;
      // 	//list of valid path needed
      // 	alert(lastValidPath);
      //router.push(lastValidPath);
    },
    goToHome() {
      let hostName = location.host.toLowerCase();
      if(hostName.includes("localhost")){
        hostName = EnvironmentInit.LocalhostDomain.toLowerCase()
      }
      if (hostName == "wysd-apac-2022.e2m.live" || hostName == "uattest.e2m.live") {
        router.push("/home");
      } else {
        let lsndingUrl = this.getEventLandingURL();
        if (lsndingUrl && ["/livestage", "/stageview"].includes(lsndingUrl)) {
          router.push("/sessions");
        } else {
          router.push(lsndingUrl);
        }
      }
    },
    initScreen() {
      self.windowSize = window.innerWidth + "X" + window.innerHeight;
      if (window.innerWidth < 768) {
        self.deviceId = "mobile_potrait";
      } else if (window.innerHeight < 600) {
        self.deviceId = "mobile_landscape";
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        if (self.iPadLandscapePlayerSupport) {
          self.deviceId = "ipad_landscape";
        } else {
          self.deviceId = "ipad_potrait";
        }
      } else {
        if (self.iPadLandscapePlayerSupport) {
          self.deviceId = "ipad_landscape";
          var lastValidPath = store.getters.getRouteName;
          //alert(self.deviceId);
          //list of valid path needed
          //alert(lastValidPath);
          router.push(lastValidPath);
        } else {
          self.deviceId = "ipad_potrait";
        }
      }
    },
  },
};
</script>